define([
  /* eslint-disable */
  'core_client_library/js/aofl-js/0.6.0/app/app',
  'text!./index.html',
  'text!./index.css'
  /* eslint-enable */
], function riqSpinnerModule(app, html, css) {
  'use strict';
  app.registerComponent('riqSpinner', {
    require: {},
    bindings: {
      hideText: '<',
      hideBackground: '<',
      size: '<'
    },
    controller: 'riqSpinnerController',
    template: html
  });
  app.registerController('riqSpinnerController', [
    '$scope',
    '$element',
    'compileService',
    function controller($scope, $element, compileService) {
      var _this = this;
      compileService.compile({css: css}, $scope, $element);
      _this.$onDestroy = function onDestroy() {};
    }
  ]);
});
